import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {TextControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/TextControl.Options";
import {FieldControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl.Options";
import {SeparatorControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/SeparatorControl.Options";
import {LinkControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/LinkControl.Options";
import {FieldSummaryOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldSummary.Options";
import {EventManager} from "shared/utilities/Events/EventManager";
import {GetControl} from "InternalShared/Events/GetControl";
import {GetControlOptions} from "InternalShared/Events/GetControlOptions";

export class PDFControlOptionsGenerator{
    public static GetControlOptions(optionsOrType:PDFControlBaseOptions|string)
    {
        let controlType:string;
        let options:any=null;
        if(optionsOrType instanceof Object)
        {
            controlType=optionsOrType.Type;
            options=optionsOrType;
        }else{
            controlType=optionsOrType;
        }

        let controlOptions=EventManager.Publish(new GetControlOptions(controlType));
        if(controlOptions==null)
            throw new Error("Invalid control option type "+controlType);

        return controlOptions.Merge(options);
    }
}